import * as React from 'react';
import styled, { css } from 'styled-components';
import Dotdotdot from 'react-dotdotdot';
import { getItem } from '@/redux/modules/item';
import { getItemUrl } from '@/utils/urls';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { safelyRender } from '@/utils/safelyRender';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { useSelector } from 'react-redux';

type Props = {
    hideLotNumbers?: boolean;
    itemId: number;
    openOnBlank?: boolean;
};

const TitleRow = (props: Props) => {
    const { hideLotNumbers, itemId, openOnBlank } = props;
    const { isSEOExcluded, lotNumber, title } = useSelector((state) => getItem(state, itemId), isEqual);

    const safeTitle = safelyRender(title, 'span');
    const itemUrl = getItemUrl(itemId, title);
    const lotNumberDisplay = lotNumber ? (
        <Text>
            {' '}
            {lotNumber}
            :&nbsp;{' '}
        </Text>
    ) : (
        <Text> &nbsp; 0000</Text>
    );

    const targetProps = openOnBlank
        ? { rel: isSEOExcluded ? 'nofollow' : '', route: false, target: '_blank' }
        : { rel: isSEOExcluded ? 'nofollow' : '', route: true };

    return (
        <ContainerDiv>
            {title ? (
                <ItemTitleText h4>
                    <Link {...targetProps} primary to={itemUrl}>
                        <Dotdotdot clamp={2}>
                            {!hideLotNumbers && lotNumberDisplay}
                            {safeTitle}
                        </Dotdotdot>
                    </Link>
                </ItemTitleText>
            ) : (
                <ItemTitleText h4>Lorem ipsum dolor sit amet, consectetur adipiscing elit</ItemTitleText>
            )}
        </ContainerDiv>
    );
};

export default React.memo<Props>(TitleRow);

const ContainerDiv = styled.div`
    position: relative;
    display: block;
    margin-bottom: 2px;
    color: ${({ theme }) => theme.colors.black};
    min-height: 48px;
    overflow: visible;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidthNum}) {
        min-height: 40px;
    }
`;

const ItemTitleStyles = css`
    display: inline-block;
    word-break: break-word;
    font-family: ${({ theme }) => theme.typography.fontSecondary};
    text-transform: capitalize;
    letter-spacing: 0.5px;
    white-space: normal;
    position: static;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidthNum}) {
        font-size: 13px;
        line-height: 18px;
    }
`;

const ItemTitleText = styled(Text)`
    ${ItemTitleStyles}
`;
